import { render, staticRenderFns } from "./GuideNotification.vue?vue&type=template&id=78fc7dad&scoped=true&"
import script from "./GuideNotification.vue?vue&type=script&lang=js&"
export * from "./GuideNotification.vue?vue&type=script&lang=js&"
import style0 from "./GuideNotification.vue?vue&type=style&index=0&id=78fc7dad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc7dad",
  null
  
)

export default component.exports